import { apiClient } from '@/lib/api/client'

export interface ChartData {
  labels: string[]
  data: number[]
}

export interface ContentPerformanceReport {
  by_status: ChartData
  by_author: ChartData
  publishing_trend: ChartData
  creation_trend: ChartData
  summary: {
    total_pages: number
    published: number
    draft: number
  }
}

export interface CategoryAnalysisReport {
  categories: Array<{
    id: number
    name: string
    page_count: number
    active: boolean
  }>
  summary: {
    total_categories: number
    active_categories: number
    total_pages: number
  }
}

export interface TagAnalysisReport {
  tags: Array<{
    id: number
    name: string
    page_count: number
    color: string
    active: boolean
  }>
  summary: {
    total_tags: number
    active_tags: number
  }
}

export interface MediaLibraryReport {
  by_type: ChartData
  upload_trend: ChartData
  summary: {
    total_files: number
    total_size: number
    average_size: number
  }
}

export const contentReportsService = {
  async getPerformanceReport(filters?: { start_date?: string; end_date?: string }): Promise<ContentPerformanceReport> {
    const params = new URLSearchParams()
    if (filters?.start_date) params.append('start_date', filters.start_date)
    if (filters?.end_date) params.append('end_date', filters.end_date)

    const response = await apiClient.get(`/analytics/content-reports/performance?${params.toString()}`)
    return response.data.data
  },

  async getCategoryAnalysis(): Promise<CategoryAnalysisReport> {
    const response = await apiClient.get('/analytics/content-reports/categories')
    return response.data.data
  },

  async getTagAnalysis(): Promise<TagAnalysisReport> {
    const response = await apiClient.get('/analytics/content-reports/tags')
    return response.data.data
  },

  async getMediaReport(filters?: { start_date?: string; end_date?: string }): Promise<MediaLibraryReport> {
    const params = new URLSearchParams()
    if (filters?.start_date) params.append('start_date', filters.start_date)
    if (filters?.end_date) params.append('end_date', filters.end_date)

    const response = await apiClient.get(`/analytics/content-reports/media?${params.toString()}`)
    return response.data.data
  },
}

